module.exports = __webpack_public_path__ + "static/img/balance.25003e15.png";